import { ISubBlockTables, TypeNameSubBlockTables } from '../../components/block-text/tables/tables';
import { ButtonURL, Text } from '../../components/block-text/texts/texts';
import { LinkPresenter } from '../commons/link.presenter';
import { RTEPresenter } from '../commons/rte.presenter';
import { ISubBlockPresenter } from '../presenter';

interface SubBlockTablesBo {
  id: number;
  CTABtn: string | null;
  CTAUrl: ButtonURL | null;
  text: Text;
  title: string | null;
}

export class SubBlockTablesPresenter implements ISubBlockPresenter {
  parse(data: SubBlockTablesBo): ISubBlockTables {
    const subBlock: ISubBlockTables = {
      __typename: TypeNameSubBlockTables,
      id: data.id,
      title: data.title || '',
      text: RTEPresenter.getRTEText(data.text),
      ctaLabel: data.CTABtn || '',
      ctaUrl: LinkPresenter.getLink(data.CTAUrl),
    };
    return subBlock;
  }
}
